import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import browser from 'browser-detect'
import BackgroundImage from 'gatsby-background-image'
import { Link } from "@components/Link"
import { useURL } from "@hooks/useURL"

import css from "@css/components/blocks/IndexSct05.module.styl"


export default function IndexHero()
{
    const q = useStaticQuery(graphql`
        query {
            title: file(relativePath: { eq: "Hero__img__title.svg" }) {
                publicURL
            }
            comming: file(relativePath: { eq: "Sct05__img__comming@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 855) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    const urls = useURL()
    return pug`
        div(className=${css.container})
            div(className=${css.inner})
                h2(className=${css.title})
                    span
                        strong 映えるいろはを、
                    br
                    span ワークショップで
                    span はじめよう。
            div(className=${css.movie})
                Image(fluid=${q.comming.childImageSharp.fluid} alt="")
            div(className=${css.inner})
                div(className=${css.button}) COMING SOON

    `
}
